import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader, Row } from "../../components/Base";
import CrewAircraftList from "../../components/CrewAircraft";
import { getCrewAircraftTypes, AircraftType } from "../../api/aircraft";

interface CrewAircraftProps {
  match: {
    params: {
      crewId: string;
    };
  };
}

const CrewAircraft: React.FC<CrewAircraftProps> = ({ match }) => {
  const { t } = useTranslation();
  const { crewId: crewIdStr } = match.params;
  const crewId = Number(crewIdStr);
  const [crewAircraftTypes, setCrewAircraftTypes] = useState<AircraftType[]>([]);

  useEffect(() => {
    (async () => {
      const types = (await getCrewAircraftTypes({ crewId })) ?? [];
      setCrewAircraftTypes(types);
    })();
  }, [crewId]);

  return (
    <>
      <PageHeader>{t("aircraft_management.types_assigned_to_a_company")}</PageHeader>
      <Row>
        <CrewAircraftList crewAircraftTypes={crewAircraftTypes} />
      </Row>
    </>
  );
};

export default CrewAircraft;
